import jQuery from 'jquery';

;(function($){

// Tab
$('.p-irTabs-list').on('click', function(){
  $(this).parent().children().not($(this)).removeClass('p-irTabs-list-on');
  $(this).addClass('p-irTabs-list-on');
  $(this).parent().next().children().removeClass('p-irTabs-body-panel-on');
  const tabsIndex = $(this).index();
  $('.p-irTabs-body-panel').eq(tabsIndex).addClass('p-irTabs-body-panel-on');
});

}(jQuery));